import { initHeroScroll } from './hero-scroll';
import { initProjectsLoop } from './projects-loop';
import { initClientsSwiper } from './clients-swiper';

export function initPageFeatures() {
    initHeroScroll();
    initClientsSwiper();
    initProjectsLoop();
}

document.addEventListener('DOMContentLoaded', initPageFeatures);
document.addEventListener('rlm:pageview', initPageFeatures);
